import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { SwiperClass } from "swiper/react";

interface IProps {

}
interface IReturnProps {
  currentIndex: number;
  setSwiperInstance: Dispatch<SetStateAction<SwiperClass | null>>;
  handleSlideChange: (swiper: SwiperClass) => void;
}

export const SlideGalleryController = (props: IProps): IReturnProps => {


  const [currentIndex, setCurrentIndex] = useState<number>(0);
  useEffect(() => {
    console.log(currentIndex)
  }, [currentIndex])

  const [swiperInstance, setSwiperInstance] = useState<SwiperClass | null>(null);
  useEffect(() => {
    if (swiperInstance == null) return;
    setCurrentIndex(swiperInstance.activeIndex)
  }, [swiperInstance])

  const handleSlideChange = (swiper: SwiperClass) => {
    setCurrentIndex(swiper.activeIndex);
  };

  return {
    currentIndex,
    setSwiperInstance,
    handleSlideChange
  }
}  